import { render, staticRenderFns } from "./LeadReport.vue?vue&type=template&id=947971fe"
import script from "./LeadReport.vue?vue&type=script&lang=js"
export * from "./LeadReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports